export const CLIENT_ACCESS_TOKEN_KEY = 'auth/ACCESS_TOKEN';
export const CLIENT_REFRESH_TOKEN_KEY = 'auth/REFRESH_TOKEN';
export const CLIENT_EXPIRATION_TOKEN_KEY = 'auth/EXPIRATION_TOKEN';
export const COOKIE_EXPIRED_DURATION_IN_DAYS = 3;
export const SCOPE_ALL = 'all';
export const TOKEN_TYPE_BEARER = 'bearer';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/auth.ts